// extracted by mini-css-extract-plugin
module.exports = {"havenVideoPlayer":"Video_havenVideoPlayer__lzLlt","video":"Video_video__7pYyi","bigPlayButton":"Video_bigPlayButton__kgrEx","hide":"Video_hide__7jQgv","timer":"Video_timer__Nk6Ci"};